import styled from "styled-components";

export const MagnifyingGlassIconWrapper = styled.div`
    display: flex;
    align-items: center;
`